export const getLayerNameByZoom = (zoom) => {
    if (zoom < 11) {
        return 'sido';
    }
    if (zoom < 14.1) {
        return 'sgg';
    }
    if (zoom < 15.5) {
        return 'emd';
    }
    return 'point';
};

export default {
    getLayerNameByZoom,
};
